export default __webpack_public_path__ + "static/media/earth.8ff7af6b.png";